import React from 'react';
import { useMeasure } from 'react-use';
import ScrollableCards from './ScrollableCards';

const CardsMeasure = ({
  children,
  className,
  handleScroll,
  itemsPerRow,
}) => {
  const [ref, { width }] = useMeasure();

  return (
    <div ref={ref} className="aridhia-cards-measure">
      <ScrollableCards className={className} handleScroll={handleScroll} width={width} itemsPerRow={itemsPerRow}>
        {children}
      </ScrollableCards>
    </div>
  );
};

export default CardsMeasure;
